import { sortBy } from '../../utils';

export const adaptBranchesToSelector = (data) => {
    const x = data.map(({ branchId, branch }) => ({ id: branchId, name: branch }));
    return sortBy(x);
};
export const adaptDoctorsToSelector = (data) => {
    const x = data.map(({ fullName, doctorId }) => ({
        id: doctorId,
        name: fullName,
    }));
    return sortBy(x);
};

export const getSpecializationsFromDoctors = doctors => doctors.reduce((acc, item) => {
    if (acc.some(({ specialityId }) => specialityId === item.specialityId)) {
        return acc;
    }
    return [ ...acc, item ];
}, []);

export const adaptSpecializationsToSelector = (data) => {
    const x = data.map(({ specialityId, specialityName }) => ({
        id: specialityId,
        name: specialityName || `mocked-name_${specialityId}`,
    }));
    return sortBy(x);
};
export const filterDoctorsBySelectedBranch = (doctors, branchId) => doctors.filter(({ branches }) => branches.some(_branchId => `${branchId}` === `${_branchId}`));
export const filterDoctorsBySelectedSpecialization = (doctors, specializationId) => doctors.filter(({ specialityId }) => `${specialityId}` === `${specializationId}`);
export const filterDoctorsBySelectedProfile = (doctors, selectedProfileOption) => doctors?.filter(({ children }) => children === selectedProfileOption);
export const findDoctorById = (doctors, doctorId) => doctors.find(({ doctorId: _doctorId }) => `${_doctorId}` === `${doctorId}`);
